import { useStoreActions } from 'common/store/use-store-actions';
import { useSidebarStore } from './service-store/service-store';
export var useSidebarActions = function () { return useStoreActions(useSidebarStore); };
